module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.a288961.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/font/notokr-regular.woff2
// module id = Mjw8
// module chunks = 0